/**
 * El texto de la letra se guarda siempre en NFC: «ñ» y «á» ocupan una sola posición, así que
 * los anclajes de acordes no se desplazan según cómo llegó el texto.
 *
 * Los anclajes cuentan unidades de código UTF-16 (el índice nativo de JavaScript) sobre el
 * texto NFC. Para letras en español coincide con los caracteres visibles.
 */
export function normalizeText(text: string): string {
  return text.normalize('NFC')
}

export function isNormalized(text: string): boolean {
  return text === text.normalize('NFC')
}

/** Normaliza saltos de línea, quita el BOM y pasa a NFC. */
export function normalizeSource(source: string): string {
  return normalizeText(source.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n'))
}
